<template>
    <div>
        换电站列表
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>